module.exports = __webpack_public_path__ + "static/PeerInvite-d95c7680a86b608a311c96eeeae9ad76.png";